import styled from "styled-components";

import color from "constants/color";
import font from "constants/font";

const Wrap = styled.div`
  position: relative;
  height: content-fit;
  display: flex;
  align-items: center;
`;
export const CheckBoxLabel = styled.label<{
  checked: boolean;
  disabled: boolean;
  eventNone: boolean;
  editable: boolean;
  disabledLabelColor?: string;
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ disabled, disabledLabelColor }) =>
    disabled ? (disabledLabelColor ?? color.form.disabledBackground) : color.text.black};
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  ${({ eventNone }) => (eventNone ? "pointer-events: none;" : "")};
  position: relative;

  &::before {
    content: "";
    display: inline-block;
    width: 22px;
    height: 22px;
    border-radius: 3px;
    border: solid 1px
      ${({ disabled, checked }) =>
        disabled ? color.form.disabledBackground : checked ? color.text.link : color.form.border};
    background-color: ${({ disabled, checked, editable }) =>
      disabled
        ? color.form.disabledBackground
        : editable
          ? checked
            ? color.text.link
            : color.form.background
          : color.text.blue};
    position: relative;
    flex-shrink: 0;
  }

  // チェックマーク（中に擬似要素として追加）
  // ラベルの上端ではなく上下中央から測る。四角はラベルに対して中央に置かれるため、
  // 上端起点だとラベルが2行に折り返したときにチェックマークだけ四角の外に出てしまう。
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    margin-top: -7px;
    left: 9px;
    width: 5px;
    height: 10px;
    border-right: 2px solid
      ${({ disabled, checked, editable }) =>
        disabled ? color.form.disabledBackground : checked ? (!editable ? "white" : color.white) : "transparent"};
    border-bottom: 2px solid
      ${({ disabled, checked, editable }) =>
        disabled ? color.form.disabledBackground : checked ? (!editable ? "white" : color.white) : "transparent"};
    transform: rotate(45deg);
    pointer-events: none;
  }

  ${({ checked, disabled, editable }) => `
    ${
      editable &&
      `&:hover::before {
    border: solid 1px
      ${disabled ? color.form.disabledBackground : checked ? color.text.linkDark : color.text.black};
    background-color: ${
      disabled ? color.form.disabledBackground : checked ? color.text.linkDark : color.form.background
    };
  }`
    }
  `}
`;

export const CheckBoxHiddenInput = styled.input.attrs({ type: "checkbox" })`
  display: none;
`;

const Span = styled.span<{ fontSize: string }>`
  font-size: ${(props) => props.fontSize};
`;

const CheckBox = ({
  id,
  checked,
  onCheck,
  label,
  disabled = false,
  eventNone = false,
  fontSize = font.size16,
  editable = true,
  disabledLabelColor,
}: {
  id: string;
  checked: boolean;
  onCheck: () => void;
  label?: string;
  disabled?: boolean;
  eventNone?: boolean;
  fontSize?: string;
  editable?: boolean;
  // Keeps the label readable while only the box is greyed out, for when the label explains what unlocks it
  disabledLabelColor?: string;
}) => {
  return (
    <Wrap>
      <CheckBoxHiddenInput
        id={id}
        checked={checked}
        onChange={editable ? onCheck : undefined}
        disabled={disabled || !editable}
      />
      <CheckBoxLabel
        htmlFor={id}
        checked={checked}
        disabled={disabled}
        eventNone={eventNone}
        editable={editable}
        disabledLabelColor={disabledLabelColor}
      >
        <Span fontSize={fontSize}>{label}</Span>
      </CheckBoxLabel>
    </Wrap>
  );
};

export default CheckBox;
